import React from 'react';
import { X } from 'lucide-react';

const EMERGENT_AUTH_URL = 'https://auth.emergentagent.com/';

const AuthModal = ({ isOpen, onClose }) => {
  const handleGoogleSignIn = () => {
    // Store current path to redirect back after OAuth
    const currentPath = window.location.pathname + window.location.search;
    localStorage.setItem('oauth_redirect_path', currentPath);
    
    // Get the current origin and set redirect to homepage
    const redirectUrl = `${window.location.origin}/`;
    const authUrl = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
    
    // Redirect to Emergent Auth
    window.location.href = authUrl;
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" 
      onClick={onClose}
    >
      <div
        className="bg-dark-card rounded-xl shadow-2xl border border-dark-border max-w-md w-full p-8"
        onClick={(e) => e.stopPropagation()}
        data-testid="auth-modal"
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-white">
            Welcome to Emergent Showcase
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-dark-bg transition-colors"
            data-testid="close-modal-button"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Description */}
        <p className="text-gray-400 mb-6">
          Sign in to submit your apps, upvote favorites, and join our community.
        </p>

        {/* Google Sign In Button */}
        <button
          onClick={handleGoogleSignIn}
          className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors font-medium flex items-center justify-center gap-3 border border-gray-300"
          data-testid="google-signin-button"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default AuthModal;
